module.exports = __webpack_public_path__ + "static/media/18.4ad6da0f.mp3";